import { withMetadata } from '../metadata'
import { getCountryCallingCode as _getCountryCallingCode } from '../../core/index'

export function getCountryCallingCode() {
	return withMetadata(_getCountryCallingCode, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/getCountryCallingCode.js
// module id = vq6I
// module chunks = 0 1